import {AccessControlledModel} from '../AccessControlledModel';
import {MindsetReport} from '@/../types/interfaces';
import { formatDatePrettyShort } from '@/helpers';
import { isEmpty, isNotEmpty, isZero } from '@/pipes';

export class MindsetReportModel extends AccessControlledModel implements MindsetReport {
	error: string = '';					// database error information

	athleteId: string;					// user Best Athletes ID
	ryzerId: string;					// user Ryzer ID

	dateCreated: Date = new Date();		// date that the assessment was created
	dateRequested?: Date;				// date that the assessment was requested

	firstName: string = '';				// First Name
	lastName: string = '';				// Last Name
	tapId: string = '';					// TAP Unique ID
	date: Date;							// Date Taken - mindset assessment date
	email: string = '';					// Email
	dateOfBirth: Date;					// Date of Birth/Age
	position: string = '';				// Self Reported Position
	school: string = '';				// School
	schoolType: string = '';			// School Type
	schoolLocation: string = '';		// School Location
	
	archetype: string = '';				// Archetype
	trafficLight: string = '';			// Traffic Light

	overall: number = 0;				// Overall TAP Score (1-100)
	mindsetFit: number = 0;				// Mindset Fit Score (0-100)
	
	mentalToughness: number = 0;		// Mental Toughness (1-100)
	composure: number = 0;				// Composure (1-100)
	confidence: number = 0;				// Confidence (1-100)
	drive: number = 0;					// Drive (1-100)
	grit: number = 0;					// Grit (1-100)

	mentalExecution: number = 0;		// Mental Execution (1-100)
	adaptability: number = 0;			// Adaptability (1-100)
	decisiveness: number = 0;			// Decisiveness (1-100)
	focusSpeed: number = 0;				// Focus Speed (1-100)

	coachability: number = 0;			// Coachability (1-100)
	attentionToDetail: number = 0;		// Attention to Detail (1-100)
	conventionality: number = 0;		// Conventionality (1-100)
	growthMindset: number = 0;			// Growth Mindset (1-100)
	informationProcessing: number = 0;	// Information Processing (1-100)

	hittingMindset: number = 0;			// Hitting Mindset (1-100)
	leadershipRating: number = 0;		// Leadership Rating (1-100)
	pressurePerformer: number = 0;		// Pressure Performer (1-100)

	load(obj: Record<string, any>): this {
		Object.assign(this, obj);

		if( obj['dateCreated'] ) this.dateCreated = new Date(obj['dateCreated']);
		if( obj['dateRequested'] ) this.dateRequested = new Date(obj['dateRequested']);
		if( obj['date'] ) this.date = new Date(obj['date']);
		if( isEmpty(this.date) ) this.date = new Date('Jan 1 2020');
		if( obj['dateOfBirth'] ) this.dateOfBirth = new Date(obj['dateOfBirth']);

		if( isEmpty(this.dateCreated) || isNaN(this.dateCreated.getTime())) this.dateCreated = new Date();
		return this;
	}

	DaysSince(date: Date) {
		const now = new Date();
		const diffInMilliseconds = now.getTime() - date.getTime();
		return Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
	}
	get DaysSinceRequest(): number {
		if( isEmpty(this.dateRequested) ) return 9999;
		return this.DaysSince(this.dateRequested);
	}
	get DaysSinceAssessment(): number {
		return this.DaysSince(this.date);
	}
	get FullName(): string {
		if (!this.firstName && !this.lastName) { return 'unspecified' }		
		return this.firstName + ' ' + this.lastName;
	}

	get HasDateOfBirth(): boolean {
		return isNotEmpty(this.dateOfBirth) && !isNaN(this.dateOfBirth.getTime());
	}
	get DateOfBirth(): string {
		if( !this.HasDateOfBirth ) return 'not specified';
		
		return formatDatePrettyShort(this.dateOfBirth);
	}

	get HasError(): boolean {
		return isNotEmpty( this.error );
	}

	EvaluationStr(item: string, noviceThreshold: number = 35) {
		if( isZero(this[item]) ) return '';
		if( this[item] < noviceThreshold ) return "N";
		return this[item].toString();
	}
}